/**
 * DaVinci REST API Client
 *
 * HTTP client for DaVinci API with retry logic and error handling.
 * Uses universal RestClient with axios-retry for exponential backoff.
 */

import { RestClient } from '../shared/restClient';
import { DAVINCI_CONFIG } from './config';

/**
 * Singleton instance of DaVinci API client
 *
 * Uses universal RestClient configured for DaVinci API.
 * Provides retry logic, error handling, and request cancellation.
 *
 * @example Basic usage
 * const response = await davinciClient.post({
 *   endpoint: '/PerformAction',
 *   data: requestBody,
 * });
 *
 * @example With schema validation
 * const response = await davinciClient.post({
 *   endpoint: '/PerformAction',
 *   data: requestBody,
 *   requestSchema: PerformActionRequestSchema,
 *   responseSchema: PerformActionResponseSchema,
 * });
 *
 * @example With cancellation
 * const controller = new AbortController();
 * const response = await davinciClient.post({
 *   endpoint: '/PerformAction',
 *   data: requestBody,
 *   signal: controller.signal,
 * });
 */
export const davinciClient = new RestClient({
  baseURL: DAVINCI_CONFIG.ENDPOINT,
  timeout: DAVINCI_CONFIG.TIMEOUT,
  retryConfig: {
    retries: DAVINCI_CONFIG.RETRY.maxAttempts,
    retryDelay: (retryCount) => {
      // Exponential backoff: 1s, 2s, 4s
      return DAVINCI_CONFIG.RETRY.initialDelay * Math.pow(2, retryCount - 1);
    },
  },
});
